// Layout constants shared across the help center frame and its pages. Kept in
// one place so the sidebar, content box, TOC rail and navbar stay in sync.

export const HELP_NAVBAR_HEIGHT = 64
export const HELP_SIDEBAR_WIDTH = 260
export const HELP_TOC_WIDTH = 300
export const HELP_CONTENT_WIDTH = 780
export const HELP_PAGE_MAX_WIDTH = 1536

// Below this the frame can't fit sidebar + article + TOC, so the TOC rail goes.
export const helpMediaTocHidden = '@media screen and (max-width: 85rem)'
